import { forwardRef, type Ref, type SVGProps } from "react";
const IconIdCardFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M26 8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2zm-14 4.265a2.02 2.02 0 0 0-2 0 1.97 1.97 0 0 0-1 1.709v.402c.017.725.325 1.415.857 1.915-.193.03-.557.11-.57.112C7.931 16.72 7 17.396 7 18.183v2.253c0 .312.256.564.571.564h6.858a.57.57 0 0 0 .571-.564v-2.253c0-.787-.932-1.464-2.286-1.78l-.571-.112c.53-.502.838-1.19.857-1.915v-.402a1.97 1.97 0 0 0-1-1.71M18 19a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0-3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconIdCardFilledSVG);
ForwardRef.displayName = "IconIdCardFilled";
export { ForwardRef as IconIdCardFilled };
